module.exports = __webpack_public_path__ + "static/media/flk.d91271ff.svg";